// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__KcAdK","header":"MessagesList_header__3yNsW","chat":"MessagesList_chat__3kavM"};